export default __webpack_public_path__ + "static/media/Contact-Blue-Bg.194c08d4.svg";